import { render, staticRenderFns } from "./ModuleNavigationBar.vue?vue&type=template&id=8a283bdc&scoped=true"
import script from "./ModuleNavigationBar.vue?vue&type=script&lang=js"
export * from "./ModuleNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./ModuleNavigationBar.vue?vue&type=style&index=0&id=8a283bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a283bdc",
  null
  
)

export default component.exports